import { kEarthRadius } from '../../utility/constants.js';
import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class GeoCoordinates extends DataModel {
  static readonly TYPE_ID: string = 'e23b1343a8674a648c9e5adc055953bf';

  constructor(
    public readonly latitude: number,
    public readonly longitude: number,
  ) {
    super();
  }

  get $typeId() {
    return GeoCoordinates.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): GeoCoordinates {
    return new GeoCoordinates(
        MapUtils.get<number>(map, 'latitude'),
        MapUtils.get<number>(map, 'longitude'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'latitude': this.latitude,
      'longitude': this.longitude,
    };
  }

  clone(): this {
    return new GeoCoordinates(
        this.latitude,
        this.longitude,
    ) as this;
  }

  isSame(other: GeoCoordinates): boolean {
    if(other === this) {
      return true;
    }

    return other.latitude === this.latitude &&
      other.longitude === this.longitude;
  }

  distance(other: GeoCoordinates): number {
    const f1: number = this.latitude * Math.PI / 180;
    const f2: number = other.latitude * Math.PI / 180;
    const df: number = (other.latitude - this.latitude) * Math.PI / 180;
    const dl: number = (other.longitude - this.longitude) * Math.PI / 180;

    const a = Math.sin(df / 2) * Math.sin(df / 2) +
              Math.cos(f1) * Math.cos(f2) *
              Math.sin(dl / 2) * Math.sin(dl / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    // return the distance in KM, not M
    return kEarthRadius * c / 1000;
  }
}

export class GeoCoordinatesBuilder extends DataModelBuilder<GeoCoordinates> {
  build(context: SerializationContext, map: SerializedData): GeoCoordinates {
    return GeoCoordinates.fromMap(context, map);
  }
}
